import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Receipt from '@deliveroo/icon-set/react/Receipt';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Modal from '@deliveroo/consumer-component-library/components/Modal';
import P from '@deliveroo/consumer-component-library/components/P';
import Span from '@deliveroo/consumer-component-library/components/Span';
import OrderReceipt from '../OrderReceipt';
import i18n from '../../utils/i18n';

import styles from './styles.scss';

class OrderItemsSummary extends Component {
  constructor() {
    super();

    this.state = {
      orderReceiptModal: false,
    };

    this.onOrderReceiptModalOpen = this.onOrderReceiptModalOpen.bind(this);
    this.onOrderReceiptModalClose = this.onOrderReceiptModalClose.bind(this);
  }

  onOrderReceiptModalOpen() {
    this.setState({
      orderReceiptModal: true,
    });
  }

  onOrderReceiptModalClose() {
    this.setState({
      orderReceiptModal: false,
    });
  }

  renderOrderReceipt() {
    return (
      <div>
        {/* eslint-disable-next-line react/button-has-type */}
        <button className={styles['receipt-link']} onClick={this.onOrderReceiptModalOpen}>
          <Span>
            <Icon component={Receipt} size={24} spacing="0 small 0 0" />
            {i18n.gettext('order_status_page.view_receipt')}
          </Span>
        </button>

        <Modal
          type="fullscreen"
          headerTitle={`${i18n.gettext('order_status_page.order')} #${
            this.props.orderDetails.orderNumber
          }`}
          appElement={this.props.appElement}
          isOpen={this.state.orderReceiptModal}
          onClose={this.onOrderReceiptModalClose}
          closeButtonLabel={i18n.gettext('closeButton.label')}
          renderFooter={() => (
            <Button isBlock onClick={this.onOrderReceiptModalClose}>
              {i18n.gettext('order_status_page.close')}
            </Button>
          )}
        >
          <OrderReceipt
            orderDetails={this.props.orderDetails}
            imageUrl={this.props.imageUrl}
            totals={this.props.totals}
            totalAmount={this.props.totalAmount}
            restaurantName={this.props.restaurantName}
            placedAtMessage={this.props.placedAtMessage}
          />
        </Modal>
      </div>
    );
  }

  render() {
    const { orderDetails, restaurantName, imageUrl, totals } = this.props;

    return (
      <div className={styles.summary}>
        <div className={styles.header}>
          <div className={styles['restaurant-image']}>
            {imageUrl && <BackgroundImage src={imageUrl} />}
          </div>
          <div className={styles['header-content']}>
            <P size="regular">{restaurantName}</P>
            <P size="small" color="grey">
              {`${i18n.gettext('order_status_page.order')} #${orderDetails.orderNumber}`}
            </P>
          </div>
        </div>
        {orderDetails.orderItems.map((item) => (
          <div key={item.name + item.quantity + item.totalPrice} className={styles.item}>
            <div className={styles['item-quantity']}>
              <P size="regular" color="grey">
                {item.quantity} x
              </P>
            </div>

            <div className={styles['item-details']}>
              <P size="regular">{item.name}</P>
              {item.modifiersDescription && (
                <P size="small" color="grey">
                  {item.modifiersDescription}
                </P>
              )}
            </div>
          </div>
        ))}
        {totals.length !== 0 && <div className={styles.footer}>{this.renderOrderReceipt()}</div>}
      </div>
    );
  }
}

OrderItemsSummary.propTypes = {
  restaurantName: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  totalAmount: PropTypes.string,
  orderDetails: PropTypes.shape({
    orderItems: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        quantity: PropTypes.number,
        totalPrice: PropTypes.string,
        modifiersDescription: PropTypes.string,
      }),
    ).isRequired,
    orderNumber: PropTypes.string,
  }).isRequired,
  totals: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.oneOf([
        'credit',
        'subtotal',
        'surcharge',
        'delivery_fee',
        'rider_tip',
        'total',
      ]),
    }),
  ),
  placedAtMessage: PropTypes.string,
  appElement: PropTypes.string,
};

OrderItemsSummary.defaultProps = {
  placedAtMessage: null,
  appElement: '#__next',
  totalAmount: null,
  totals: [],
};

export default OrderItemsSummary;
